import React from 'react'

const getMatchingPathnames = (pathname: string): string[] => {
  if (pathname.startsWith('/accept/')) {
    // Purchased QB pages now live under /accept/*, but some exact-path consumers still use
    // the legacy purchased route names like /mileage. Match both until those callers are unified.
    return [pathname, pathname.replace(/^\/accept/, '')]
  }

  return [pathname]
}

const CustomSwitch = ({ children, showOn }: { children: React.ReactNode; showOn: string[] }) => {
  const matchingPathnames = getMatchingPathnames(window.location.pathname)

  return showOn.some((path) => matchingPathnames.includes(path)) ? <>{children}</> : null
}

export default CustomSwitch
